module.exports = function (hostname) {
  const part = hostname.replace(/^www\./, '').split('.')[0]
  if (part === 'toasttab') {
    return 'prod'
  }
  if (part === 'localhost' || !isNaN(part)) {
    return 'dev'
  }
  return part
}
